<div class="success-dialog-container">
  <button mat-dialog-close type="button" class="btn-close-custom" aria-label="Close">
    <i class="bi bi-x"></i>
  </button>

  <div class="success-header">
    <div class="icon-wrapper">
      <div class="confetti-dots">
        <span class="dot d1"></span>
        <span class="dot d2"></span>
        <span class="dot d3"></span>
        <span class="dot d4"></span>
        <span class="dot d5"></span>
        <span class="dot d6"></span>
      </div>
      <div class="check-circle">
        <i class="bi bi-check-lg"></i>
      </div>
    </div>
  </div>

  <div class="success-body text-center mt-4">
    <h2 class="success-title">{{ data.modalTitle }}</h2>
    <p class="success-text text-muted">{{ data.modalText }}</p>
  </div>

  <div class="success-footer mt-4">
    @if(this.data.pageReference =='update-seller-catalog'){
      <button type="button" class="btn btn-secondary-custom w-100 mb-2" (click)="addAnotherEntry()">
        Add another brand
      </button>
    }
    <button type="button" class="btn btn-primary-custom w-100" (click)="moveToCatalog()">
      {{ data.buttonLabel || 'Browse More' }}
    </button>
  </div>
</div>
